import { render, staticRenderFns } from "./ReportView.vue?vue&type=template&id=22c1e368&scoped=true&"
import script from "./ReportView.vue?vue&type=script&lang=ts&"
export * from "./ReportView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c1e368",
  null
  
)

export default component.exports